import script from "./CriminalRecordTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CriminalRecordTable.vue?vue&type=script&setup=true&lang=js"

import "./CriminalRecordTable.vue?vue&type=style&index=0&id=b71a05b0&scoped=true&lang=scss"
script.__scopeId = "data-v-b71a05b0"

export default script